<script lang="ts" module>
  import { onDestroy } from 'svelte';

  import type { TeoText } from '@/teoCore/text/TeoText';
  import TpiDrawer from '@/ui/elements/tpi-drawer/TPIDrawer.svelte';
  import { useTeoTextUiStateObserver } from '@/utils/use-teo-event-observer.svelte';

  import {
    createDictionaryPillGroups,
    type DictionaryPillGroup,
  } from './DictionaryDrawerComponent';
</script>

<script lang="ts">
  let { teoText }: { teoText: TeoText } = $props();
  const dimensionDrawerOpen = useTeoTextUiStateObserver(teoText.ui, 'dimensionDrawerOpen');
  const category = useTeoTextUiStateObserver(teoText.ui, 'dictionaryCategory');
  const wordListName = useTeoTextUiStateObserver(teoText.ui, 'dictionaryWordList');

  let pillgroups: DictionaryPillGroup[] = $state([]);

  onScan();

  teoText.wordLists.events.addEventListener('gotScanResult', onScan);

  onDestroy(() => {
    teoText.wordLists.events.removeEventListener('gotScanResult', onScan);
  });

  function onScan() {
    pillgroups = createDictionaryPillGroups(teoText.wordLists.dictionary);
  }

  function onDimensionChange(dm: string | undefined) {
    teoText.ui.update('dictionaryCategory', dm);
  }

  function onTextPropertyChange(tp: string | undefined) {
    teoText.ui.update('dictionaryWordList', tp);
  }
</script>

<TpiDrawer
  open={dimensionDrawerOpen.current}
  pillGroups={pillgroups}
  useableSubdims={['subdim1', 'subdim2', 'subdim3']}
  dimension={category.current}
  textProperty={wordListName.current}
  helpTopicName="word-lists"
  {onDimensionChange}
  {onTextPropertyChange}
></TpiDrawer>
